import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';

export const initializeAdyenCheckout = async () => {
    const response = await fetch('/actions/cart.cfc?method=getAdyenConfig')
    const config = await response.json()

    if (!config.clientKey || !config.environment) {
        throw new Error('Invalid Adyen configuration')
    }

    // Initialize Adyen Checkout
    return new AdyenCheckout(config)
};
